import { FileType, emptyValidationResponse } from '../urlValidationUtils'

const DropboxValidator = (url: string) => {
  let regexGroups = /(?:https:\/\/)?(?:www.)?([\w\-_]+).com\/s\/(.*)(pdf|png|jpeg|jpg)/.exec(url)
  if (regexGroups?.[0])
    return {
      validUrl: `https://www.dropbox.com/s/${regexGroups[2]}${regexGroups[3]}?raw=1`,
      isEmbeddable: true,
      newFileSubType: regexGroups[3] === FileType.PDF ? FileType.PDF : FileType.IMAGES,
    }

  return emptyValidationResponse
}

export default DropboxValidator
